/**
 * Le indica al lienzo V2 qué juego a pantalla completa debe mostrar.
 * @param {number} screenId - ID de la pantalla (Ej. 1)
 * @param {string|null} dynamicName - Nombre del juego (Ej. 'RunToGoal'). Manda 'null' para limpiar la pantalla.
 */
const SetScreenV2MainDynamic = async (screenId, dynamicName) => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}Screen/${screenId}/MainDynamic`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ dynamicName: dynamicName })
        });
    } catch (error) {
        console.error("Error enviando comando al Súper Lienzo V2", error);
    }
};

/**
 * Prende o apaga un widget flotante (Overlay) en el lienzo V2.
 */
const ToggleScreenV2Overlay = async (screenId, overlayName, isVisible) => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}Screen/${screenId}/Overlay`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ overlayName: overlayName, isVisible: isVisible })
        });
    } catch (error) {
        console.error("Error enviando comando de Overlay al Súper Lienzo V2", error);
    }
};

export { SetScreenV2MainDynamic, ToggleScreenV2Overlay };